/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {useEffect, useState} from 'react';
import {useHasMounted} from '@ion/core/src/hooks/useHasMounted';
import {Group} from '@ion/core/src/types/entities';
import {sortByString} from '@ion/core/src/utils/ArrayUtil';
import {useLoadGroups} from '@ion/query/src/hooks/useLoadGroups';

export interface UseGroupAssignmentDetailsFormResult {
  groups?: Group[];
  groupsResult?: Group[];
  areGroupsLoading?: boolean;
}

/**
 * Re-usable hook for returning groups.
 */
export const useGroupAssignmentDetailsForm = (accountId): UseGroupAssignmentDetailsFormResult => {
  const {groups, isLoading}                     = useLoadGroups({accountId});
  const hasMounted                              = useHasMounted();
  const [areGroupsLoading, setAreGroupsLoading] = useState(true);
  const [allGroups, setAllGroups]               = useState([]);

  useEffect(function(): void {
    setAreGroupsLoading(isLoading);
  }, [isLoading]);

  // whenever the account changes the groups are reloaded ...
  useEffect(() => {
    const getGroupsData = () => {
      if (hasMounted !== false) {
        const groupList = sortByString(groups, 'name');
        setAllGroups(groupList);
      }
    };
    getGroupsData();
  }, [groups]);

  return {
    groups       : allGroups,
    groupsResult : groups,
    areGroupsLoading
  };
};
